<template>
  <v-tooltip top>
    <template v-slot:activator="{ on, attrs }">
      <div class="d-flex align-center" v-bind="attrs" v-on="on">
        <div class="progress-container-max">
          <div class="progress-container" :style="visitBoxWidth">
            <div class="progress-value-gray" :style="visitValueWidth"></div>
          </div>
        </div>
        <div class="font-small m-l-5">
          {{
            `${
              total === 0 ? 0 : Math.round(((total - remaining) * 100) / total)
            }%`
          }}
        </div>
      </div>
    </template>
    <span>
      {{ (total - remaining) | decimalFormat }} of
      {{ total | decimalFormat }} leads completed<br />{{
        remaining | decimalFormat
      }}
      leads remaining
    </span>
  </v-tooltip>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    total: Number,
    remaining: Number
  },
  data() {
    return {
      visitBoxWidth: { width: '100%' },
      visitValueWidth: { width: '0%' }
    }
  },
  watch: {
    remaining: {
      immediate: true,
      handler() {
        setTimeout(() => {
          this.visitBoxWidth = {
            width: `${
              this.total === 0
                ? 100
                : Math.round((this.total * 100) / this.total)
            }%`
          }
          this.visitValueWidth = {
            width: `${
              this.total === 0
                ? 0
                : Math.round(((this.total - this.remaining) * 100) / this.total)
            }%`
          }
        }, 100)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.title-progress {
  color: #333333;
  font-weight: 800;
  font-size: 18px;
}

.progress-label {
  width: 30px;
  text-align: right;
  font-size: 0.875rem;
}

.progress-container-max {
  height: 5px;
  width: 150px;
  background: white;
  margin-top: -3px;

  .progress-container {
    height: 5px;
    background: #d9d9d9;
    border-radius: 3px;

    .progress-value-gray,
    .progress-value-red {
      height: 5px;
      line-height: 5px;
      color: white;
      text-align: right;
      font-size: 0.7rem;
      transition: width 0.8s;
      border-radius: 3px;

      span {
        margin-right: 5px;
      }
    }
    .progress-value-gray {
      background: #666666;
    }

    .progress-value-red {
      background: $primary;
    }
  }
}
.font-small {
  font-size: 10px;
  margin-top: -5px;
}
</style>
